import { dealjacketConstants, dl_insuranceConstants } from "../constants";

const populateImages = (jacket) => {
  let images = [];
  for (let i = 0; i < jacket.pages.length; i++) {
    images[i] = {
      source: jacket.pages[i].imageUrl,
      caption: jacket.pages[i].page_type,
    };
  }
  return images;
};

const initialState = {};

export function dealjackets(state = initialState, action) {
  switch (action.type) {
    case dealjacketConstants.DEALJACKET_LIST_REQUEST:
      return {
        isLoading: true,
      };

    case dealjacketConstants.DEALJACKET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.list,
      };

    case dealjacketConstants.DEALJACKET_LIST_FAILURE:
      return {
        error: action.error,
      };

    case dealjacketConstants.DEALJACKET_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case dealjacketConstants.DEALJACKET_DETAIL_SUCCESS:
      let currentJacket = {
        images: populateImages(action.pages),
        ...action.pages,
      };
      return {
        ...state,
        isLoading: false,
        current: currentJacket,
      };

    case dealjacketConstants.DEALJACKET_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case dealjacketConstants.DEALJACKET_UPLOAD_REQUEST:
      return state;

    case dealjacketConstants.DEALJACKET_UPLOAD_SUCCESS:
      return state;

    case dealjacketConstants.DEALJACKET_UPLOAD_FAILURE:
      return state;

    case dealjacketConstants.DEALJACKET_EDIT_NAME_REQUEST:
      return state;

    case dealjacketConstants.DEALJACKET_EDIT_NAME_SUCCESS:
      const returnval = action.jacket;
      returnval.images = populateImages(returnval);

      return {
        ...state,
        current: returnval,
      };

    case dealjacketConstants.DEALJACKET_EDIT_NAME_FAILURE:
      return state;

    case dealjacketConstants.DEALJACKET_EDIT_REQUEST:
      return state;

    case dealjacketConstants.DEALJACKET_EDIT_SUCCESS:
      var retval = action.jacket;

      return {
        ...state,
        current: retval,
        searchResults: {...state.searchResults, results: state.searchResults.results.map(r => r.deal_jacket_id!==action.jacket.deal_jacket_id?r:action.jacket)}
      };

    case dealjacketConstants.DEALJACKET_EDIT_FAILURE:
      return state;
  

    case dealjacketConstants.SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchTerm: action.searchRequest.term,
        // searchResults: null,
      };
    case dealjacketConstants.SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        searchResults: action.list,
        queryString: action.list.query_string,
      };
    case dealjacketConstants.SEARCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        searchResults: null,
      };
    case dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        check_deal_number_response: action
      };

    case dl_insuranceConstants.DL_INSURANCE_CLEAR_DEAL_JACKET_SUCCESS:
      return {
        ...state,
        jackets_matching_requested_number: undefined,
        check_deal_number_response: undefined,
      }

    case "search_request_violation":
      return {
        ...state,
        search_request_violation: true,
      }

      case "clear_search_request_violation":
        return {
          ...state,
          search_request_violation: false,
        }


    case dealjacketConstants.DEALJACKET_CHECK_DEAL_NUMBER_FAILURE:
      return {
        ...state,
        isLoading: false,
        searchResults: null,
        check_deal_number_response: action
      };

    case dl_insuranceConstants.DL_INSURANCE_CREATE_JACKET_FROM_DEAL_NUMBER_SUCCESS:
      return {
        ...state,
        check_deal_number_response: undefined,
      }

    case dl_insuranceConstants.DL_INSURANCE_CLEAR_DEAL_NUMBER_REQUEST:
      return {
        ...state,
        check_deal_number_response: undefined,
      }

    case dealjacketConstants.DEALJACKET_UPLOAD_MULTIPLE_FILES_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case dealjacketConstants.DEALJACKET_UPLOAD_MULTIPLE_FILES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        file_added: "TODO File Name"
      }

    case dealjacketConstants.DEALJACKET_UPLOAD_MULTIPLE_FILES_FAILURE:
      return {
        ...state,
        error: "TODO: ERROR",
      }

    case dealjacketConstants.CLEAR_JACKETS:
      return initialState;
    default: {
      return state;
    }

    case dealjacketConstants.DEALJACKET_CLEAR_SEARCH:
      return {
        ...state,
        isLoading: false,
        searchResults: undefined,
        queryString: undefined
      }
  }
}
